import { isEmpty } from "lodash";

const DESCENT = 0.25;
const ASCENT = 0.9;

export const textItems = (items) =>
  items.filter((item) => !isEmpty(item.str) && Array.isArray(item.transform));

export const itemSize = (item) => {
  const [, , c, d] = item.transform;
  return Math.hypot(c, d) || item.height || 1;
};

const unit = (x, y, fallback) => {
  const length = Math.hypot(x, y);
  return length > 0 ? [x / length, y / length] : fallback;
};

export const portionOf = (item, from, to) => {
  const [a, b, c, d, e, f] = item.transform;
  const length = item.str.length;
  const height = itemSize(item);
  const [ux, uy] = unit(a, b, [1, 0]);
  const [vx, vy] = unit(c, d, [-uy, ux]);
  const along = [(item.width * from) / length, (item.width * to) / length];
  const across = [-DESCENT * height, ASCENT * height];
  const points = along.flatMap((s) =>
    across.map((h) => [e + ux * s + vx * h, f + uy * s + vy * h]),
  );
  const xs = points.map(([x]) => x);
  const ys = points.map(([, y]) => y);
  return {
    x1: Math.min(...xs),
    y1: Math.min(...ys),
    x2: Math.max(...xs),
    y2: Math.max(...ys),
    baseline: e * vx + f * vy,
    height,
  };
};

export const unionRect = (left, right) => ({
  ...left,
  x1: Math.min(left.x1, right.x1),
  y1: Math.min(left.y1, right.y1),
  x2: Math.max(left.x2, right.x2),
  y2: Math.max(left.y2, right.y2),
});

export const viewportRect = (viewport, { x1, y1, x2, y2 }) => {
  const [left, top, right, bottom] = viewport.convertToViewportRectangle([
    x1,
    y1,
    x2,
    y2,
  ]);
  return {
    left: Math.min(left, right),
    top: Math.min(top, bottom),
    width: Math.abs(right - left),
    height: Math.abs(bottom - top),
  };
};
